<template>
    <div class="Map" app>
        <Navbar />
        
        <v-content class="Map">
            <v-skeleton-loader
                width="100%"
                type="image"
                :style="`display: ${loading}; position: fixed; height: 100% !important; z-index: 1000`"
            ></v-skeleton-loader>

            <div id="map_div"></div> 
        </v-content>
    </div>
</template>

<style>
    #map_div, .Map{
        height: 100%;
    }
    .v-skeleton-loader div{
        height: 100%;
    }
</style>

<script>
import Navbar   from '@/components/Navbar.vue';
import api      from '@/plugins/apisauceHeader.js';
import router   from '@/router/index.js';

let cluster = null;

export default {
    name: 'CRUD',
    components:{
        Navbar
    },
    data: () => ({
        loading: "block",
        customization: {},
        markers: {},
        infowindow: {},
        cluster: null,
        timeToUpdate: 300,
        timer: null
    }),
    methods: {
        createMarkers(){
            if(cluster != null)
                cluster.clearMarkers();
            
            const locations = Object.keys(this.markers).map(m=>{
                return this.markers[m];
            })
            var markers = locations.map(function(location) {
                // eslint-disable-next-line no-undef
                return new google.maps.Marker(location);
            });
            markers.forEach(marker=>{
                marker.addListener('click', (r)=>{ 
                    window.map.setCenter(r.latLng);
                    // eslint-disable-next-line no-undef
                    window.infoWindow = new google.maps.InfoWindow({
                        content: marker.balao
                    });
                    window.infoWindow.open(window.map, marker);
                });
            });
            
            // eslint-disable-next-line no-undef
            cluster = new MarkerClusterer(window.map, markers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', maxZoom: 18});
        },
        getDeviceLocation(){
            api(localStorage.getItem("token")).get(`endpoint/veiculos_mapa/addwhere=idcliente:${localStorage.getItem("idcliente")}`).then(r=>{
                if(r.ok){
                    r.data.endpoint.forEach(e=>{
                        if(e.latitude != null && e.longitude != null){
                            if(!this.markers[e.iddevice]){
                                // eslint-disable-next-line no-undef
                                this.markers[e.iddevice] = {
                                    label: `${e.placa} ${e.speed > 2.77777 ? ' - Em trânsito' : ''}`,
                                    position: {
                                        lat: e.latitude,
                                        lng: e.longitude
                                    },
                                    balao: e.balao,
                                    // eslint-disable-next-line no-undef
                                    animation: google.maps.Animation.Go,
                                    icon: {
                                        url: e.icone_tipo ? new Buffer(e.icone_tipo.data).toString() : "https://i.imgur.com/WXK1hoi.png",
                                        // eslint-disable-next-line no-undef
                                        scaledSize: new google.maps.Size(50, 50), // scaled size
                                        // eslint-disable-next-line no-undef
                                        origin: new google.maps.Point(0, 20), // origin
                                        // eslint-disable-next-line no-undef
                                        anchor: new google.maps.Point(25, 25) // anchor
                                    }
                                };
                            }else
                                this.markers[e.iddevice].position = {
                                    lat: e.latitude,
                                    lng: e.longitude
                                };
                        }
                    });
                    this.createMarkers();
                    this.loading = "none";
                }
            })
        },
        initMap(){
            // eslint-disable-next-line no-undef
            window.map = new google.maps.Map(document.getElementById('map_div'),
            { 
                zoom: 15, 
                mapTypeId: 'satellite',
                center:  {
                    lat: -22.5623944,
                    lng: -47.4272929,
                }, 
                disableDefaultUI: true }
            );
            
            navigator.geolocation.getCurrentPosition((local)=>{
                window.map.setCenter({
                    lat: local.coords.latitude,
                    lng: local.coords.longitude
                })
            });

            this.getDeviceLocation();
        },
        tryInit(){
            setTimeout(() => {
                if(typeof(google) != "undefined")
                    this.initMap();
                else
                    this.tryInit();
            }, 1000);
        }
    },
    mounted(){
        if(!localStorage.getItem("usrId")) router.push('/');
        if(localStorage.getItem("intervalo_posicoes")) this.timeToUpdate = parseInt(localStorage.getItem("intervalo_posicoes"));
        this.customization = JSON.parse(localStorage.getItem("customization"));
        document.title = `${this.customization.name} - Mapa`;

        if(typeof(google) != "undefined")
            this.initMap();
        else
            this.tryInit();

        this.timer = setInterval(() => {
            this.getDeviceLocation();
        }, this.timeToUpdate * 1000);
    },
    beforeDestroy(){
        clearInterval(this.timer);
    }
}
</script>